import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  selectDetailsFetchData,
  selectDetailsData,
  selectListFetchData
} from 'src/core/redux/selectors';
import { User, UserType } from 'src/core/models';
import { FetchData } from 'src/core/components';
import LocalStorageService from 'src/core/services/LocalStoregeService';
import { config } from 'src/constants';

import { fetchAccessAndUserData, resetUserDetails } from './actions';
import AppComponent from './AppComponent';

const AppContainer = ({
  isFetching,
  fetchData,
  resetData,
  fetched,
}) => {
  useEffect(() => {
    if (fetched && !(config.isDevEnv)) {
      window.showGlobalFooter();
    }
  }, [fetched]);

  return (
    <FetchData
      isFetching={isFetching}
      fetchData={fetchData}
      resetData={resetData}
    >
      <AppComponent />
    </FetchData>
  );
};

AppContainer.propTypes = {
  isFetching: PropTypes.bool,
  fetchData: PropTypes.func.isRequired,
  resetData: PropTypes.func.isRequired,
  fetched: PropTypes.bool,
};

const mapStateToProps = (state) => {
  const userType = selectDetailsData(UserType)(state);
  const userDetails = selectDetailsData(User)(state);

  LocalStorageService.setLoggedUser(
    new User({
      ...userDetails,
      isAnonymous: userType.isAnonymous
    })
  );

  const fetchUserTypeDataProps = selectDetailsFetchData(UserType)(state);
  const fetchUserDetailsProps = selectListFetchData(User)(state);

  return {
    isFetching: userType.isAnonymous ?
      fetchUserTypeDataProps.isFetching : fetchUserDetailsProps.isFetching,
    fetched: userType.isAnonymous ?
      fetchUserTypeDataProps.fetched : fetchUserDetailsProps.fetched,
  };
};

const mapDispatchToProps = {
  fetchData: fetchAccessAndUserData,
  resetData: resetUserDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
